module.exports = __webpack_public_path__ + "img/avatar2.47ca8810.png";